export default __webpack_public_path__ + "static/media/d_monografia.13119f12.png";